export const UPDATE_LOGIN_RESULT = 'UPDATE_LOGIN_RESULT'
export const IS_LOGGED_IN = 'IS_LOGGED_IN'
